<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
  >
    <path
      d="M8.60026 15.4769C12.2821 15.4769 15.2669 12.4921 15.2669 8.81022C15.2669 5.12832 12.2821 2.14355 8.60026 2.14355C4.91836 2.14355 1.93359 5.12832 1.93359 8.81022C1.93359 12.4921 4.91836 15.4769 8.60026 15.4769Z"
      stroke="currentColor"
    />
    <path
      d="M8.60547 7.81602C8.0532 7.81602 7.60547 8.26375 7.60547 8.81602C7.60547 9.36828 8.0532 9.81602 8.60547 9.81602C9.15774 9.81602 9.60547 9.36828 9.60547 8.81602C9.60547 8.26375 9.15774 7.81602 8.60547 7.81602ZM8.60547 7.81602V5.47656M10.6101 10.8237L9.311 9.52468"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>